import React, { Dispatch, FC, SetStateAction } from 'react';
import styles from './AddNewPaymentMethod.module.scss';
import plusIcon from '../../../assets/img/plusIcon.svg';
import plusIconInactive from '../../../assets/img/plusIconInactive.svg';
import plusIconWithContrast from '../../../assets/img/plusIconWithContrast.svg';
import { generateImageUrl } from '../../../utils/cdnService';
import masterCard from '../../../assets/img/masterCard.svg';
import visa from '../../../assets/img/visa.svg';
import sepa from '../../../assets/img/sepaLogo.svg';

interface AddNewPaymentMethodI {
  isSepa: boolean;
  handleSepaShow?: Dispatch<SetStateAction<boolean>>;
  handleRocektGatePayment?: () => void;
}

const AddNewPaymentMethod: FC<AddNewPaymentMethodI> = ({ isSepa, handleSepaShow, handleRocektGatePayment }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const withContrast = true;

  const handleClick = () => {
    if (isSepa) {
      handleSepaShow && handleSepaShow(true);
    }

    if(handleRocektGatePayment){
      handleRocektGatePayment();
    }
  };

  return (
    <div
      onClick={handleClick}
      onMouseLeave={() => setIsHovered(false)}
      onMouseEnter={() => setIsHovered(true)}
      className={`${styles.container} ${withContrast ? styles.contrast : ''}`}    >
      <div>
        <img   src={
          withContrast
            ? (isHovered ? plusIconWithContrast : plusIconInactive)
            : (isHovered ? plusIcon : plusIconInactive)
        } alt="plusIcon" />
      </div>
      {isSepa ? (
        <div>
          <img src={`${generateImageUrl('gcore', 0, 0, 'payment_methods/v5/sepa.svg?width=160')}`} alt="" />
        </div>
      ) : (
        <div className={styles.visaMaser}>
          <img src={`${generateImageUrl('gcore', 0, 0, 'payment_methods/v3/visaMastercard_logo.svg?width=160')}`} alt="" />
        </div>
      )}
    </div>
  );
};

export default AddNewPaymentMethod;
